export default {
  app: {
    orgCode: "Group/Brand Number",
    orgCodePlaceholder: "Please enter the group/brand number",
    username: "Account",
    usernamePlaceholder: "Please enter an account",
    password: "Password",
    passwordPlaceholder: "Please enter the password",
    captcha: "Verification Code",
    captchaPlaceholder: "Please enter the verification code",
    captchaExpired: "Please refresh the verification code",
    login: "Login",
    remember: "Remember login information",
    switchPC: "Switch to backend",
    mobileVersion: "Mobile BI",
    desktopVersion: "Merchant's Backend",
    setupPassword: "Set password",
    newPassword: "New Password",
    newPasswordPlaceholder: "Please enter a new password",
    retypePassword: "Enter the new password again",
    retypePasswordPlaceholder: "Please enter the new password again.",
    setupPasswordRule: "The password must be 6-32 characters long and contain at least two of the following: numbers, letters, symbols.",
    setupPasswordRuleRefer: "Password must be 6 to 32 characters and contain at least two of the following: numbers, letters, and symbols. Please try again.",
    setupPasswordOk: "Confirm",
    setupPasswordDiffer: "The passwords entered do not match. Please try again.",
    err_def: "Login failed. Please refresh the page and try again.",
    err_2000: "Verification code error.",
    err_2010: "Incorrect login information entered.",
    err_4001: "The account is not authorized for any functions.",
    err_4011: "Store has been disabled, unable to log in.",
    err_4012: "Franchisee has been disabled, unable to log in.",
    err_4013: "Brand has been disabled, unable to log in.",
    err_4014: "Unable to log in. The group has been disabled.",
    err_4015: "The region has been deactivated and login is not possible.",
    err_4401: "This account is not authorized for this store.",
    err_4402: "This account has no admin privileges to obtain the verification code.",
    err_5001: "Password setup failed. Please try again.",
  },
  verifyRefund: {
    title: "Return Request",
    hint: "Please confirm the return information before providing the verification code.",
    verifyCode: "Verification Code",
    copy: "Copy",
    copySucceed: "Copy successful.",
    copyFailed: "Copy failed.",
    expireTime: "Expiration Time",
    shop: "Store",
    soTime: "Order Time",
    soNo: "POS Order No.",
    amount: "Refund Amount",
  },
}